import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import { i18n } from './i18n';
import './quasar';
import { compass } from '@resclick/compass';
import PortalVue from 'portal-vue';
import 'vue-class-component/hooks';
import VueCurrencyInput from 'vue-currency-input';

import Cart from './components/Cart.vue';
import EntityModalTab from './components/EntityModalTab.vue';
import '@resclick/crs-ui/dist/bundle.css';
import {
  QSelectDynamic,
  QSelectBox,
  QAddressInput,
  QPhoneInput,
  CrsFormPack,
  DisableAutocomplete,
  FilterPack,
  QTranslate,
  QDataTable,
  QDateInput,
} from '@resclick/crs-ui';

// @ts-ignore
import VCalendar from 'v-calendar';
// @ts-ignore
import VueGoogleMap from 'vuejs-google-maps';
import Layout from '@/components/Layout.vue';
import Toolbar from '@/components/Toolbar.vue';
import EntityModal from '@/components/EntityModal.vue';

compass.httpConfig({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Authorization: `Bearer ${store.state?.auth?.accessToken}`,
  },
});

let lastQueryTime = 0;
compass.interceptors.request.use(async (value) => {
  const currentTime = Date.now();

  if (lastQueryTime < currentTime && store.state.auth?.id) {
    lastQueryTime = currentTime + 10000;
    store.dispatch('user/getProfile', store.state.auth?.id).then();
  }

  return value;
});

compass.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    if (error.response.status === 401 && router.currentRoute.path !== '/login') {
      router.replace('/login').then();
    }
    return Promise.reject(error?.response || error);
  },
);

Vue.component('Layout', Layout);
Vue.component('Toolbar', Toolbar);
Vue.component('EntityModal', EntityModal);
Vue.component('EntityModalTab', EntityModalTab);
Vue.component('QDateInput', QDateInput);
Vue.component('Cart', Cart);
Vue.component('QSelectBox', QSelectBox);
Vue.component('QSelectDynamic', QSelectDynamic);
Vue.component('QDataTable', QDataTable);
Vue.component('QAddressInput', QAddressInput);
Vue.component('QPhoneInput', QPhoneInput);
Vue.component('QTranslate', QTranslate);
Vue.use(VueCurrencyInput, {});
Vue.use(FilterPack);

Vue.use(CrsFormPack, { i18n });
Vue.use(DisableAutocomplete);
Vue.use(PortalVue);
Vue.use(VCalendar);

Vue.use(VueGoogleMap, {
  load: {
    apiKey: 'AIzaSyClZwhlpblfend-fx4z79WmqfyV2TaHl4c',
    libraries: [], // necessary for places input
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
